export default {
  PRE_BOOKING: "1",
  POST_BOOKING: "2",
} as const;
